export const styleOverrides = {
  root: ({ theme }) => ({
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    minHeight: 0,
    "& .MuiAccordionSummary-content": {
      margin: 0,
      minHeight: 0,
      padding: 0,
    },
  }),
};
